import React, { useState, useEffect } from 'react';
import { Flame } from 'lucide-react';

export default function Header({ lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const t = {
    login: lang === 'bg' ? 'ВХОД' : 'LOGIN',
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0f172a]/95 backdrop-blur-md shadow-lg shadow-black/30' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center shadow-lg shadow-orange-500/30">
              <Flame className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl md:text-2xl font-black tracking-tight">
              <span className="text-orange-500">Sport</span>
              <span className="text-white">App</span>
              <span className="text-amber-400">Pros</span>
            </span>
          </a>

          {/* Right side */}
          <div className="flex items-center gap-3 md:gap-4">
            {/* Language toggle */}
            <button
              onClick={() => setLang(lang === 'bg' ? 'en' : 'bg')}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 transition-all duration-200 text-sm font-semibold tracking-wide"
            >
              <span className="text-base">{lang === 'bg' ? '🇧🇬' : '🇬🇧'}</span>
              <span className="text-white">{lang === 'bg' ? 'BG' : 'EN'}</span>
              <span className="text-white/40 text-xs">↕</span>
              <span className="text-white/60 text-xs">{lang === 'bg' ? 'EN' : 'BG'}</span>
            </button>

            {/* Login button */}
            <a
              href="/s"
              className="px-4 md:px-6 py-2 rounded-full border-2 border-orange-500 text-orange-500 font-bold text-sm tracking-widest hover:bg-orange-500 hover:text-white transition-all duration-200 uppercase"
            >
              {t.login}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
